import { createFileRoute } from '@tanstack/react-router'

import i18n from '@/i18n'
import { UsersListView, usersFiltersSchema } from '@/modules/users'
import { getMetaWithPageTitle } from '@/utils/get-page-title'

export const Route = createFileRoute('/_auth/users/')({
  validateSearch: usersFiltersSchema,
  component: UsersListView,
  head: () =>
    getMetaWithPageTitle([
      i18n.t('title.teachers-and-panel-users', { ns: 'users' })
    ])
})
